import React from "react";
import { Copy } from "lucide-react";

const sel = (elegidos, r) => elegidos[r.fila] ?? r.roge.complementos.map((c) => c.idx);

export const DuplicadosRoge = ({ rows, elegidos, setElegidos }) => {
  if (!rows.length) return null;
  const toggle = (r, idx) => {
    const act = sel(elegidos, r);
    setElegidos({ ...elegidos, [r.fila]: act.includes(idx) ? act.filter((i) => i !== idx) : [...act, idx] });
  };
  return (
    <div className="rounded-xl border border-violet-200 bg-violet-50/50 p-4" data-testid="duplicados-roge">
      <p className="flex items-center gap-2 text-sm font-semibold text-violet-800"><Copy className="h-4 w-4" /> Empleados que ya existen en Roge ({rows.length})</p>
      <p className="mt-0.5 text-xs text-violet-700/80">Los datos de Roge se conservan. Solo puedes tomar del archivo los campos que en Roge están vacíos: marca los que quieres completar.</p>
      <div className="mt-3 space-y-3">
        {rows.map((r) => (
          <div key={r.fila} className="rounded-lg border border-violet-100 bg-white p-3" data-testid={`dup-roge-${r.fila}`}>
            <p className="text-sm font-medium text-slate-800">{r.roge.nombre_roge || r.resumen.nombre_completo || "—"} <span className="text-xs font-normal text-slate-400">· C.C. {r.resumen.cedula} · fila {r.fila}</span></p>
            {r.roge.complementos.length > 0 && (
              <div className="mt-2">
                <p className="text-xs font-semibold text-emerald-700">Datos nuevos (vacíos en Roge)</p>
                <div className="mt-1 grid gap-1 sm:grid-cols-2">
                  {r.roge.complementos.map((c) => (
                    <label key={c.idx} className="flex items-start gap-2 text-xs text-slate-700">
                      <input type="checkbox" className="mt-0.5 h-3.5 w-3.5 accent-vino-700" checked={sel(elegidos, r).includes(c.idx)} onChange={() => toggle(r, c.idx)} data-testid={`dup-roge-${r.fila}-campo-${c.idx}`} />
                      <span className="break-words"><span className="font-medium">{c.campo}:</span> {c.nuevo}</span>
                    </label>
                  ))}
                </div>
              </div>
            )}
            {(r.roge.conflictos || []).length > 0 && (
              <div className="mt-2">
                <p className="text-xs font-semibold text-slate-500">Datos distintos · se conserva lo de Roge</p>
                <ul className="mt-1 space-y-0.5 break-words text-xs text-slate-500" data-testid={`dup-roge-${r.fila}-conflictos`}>
                  {r.roge.conflictos.map((c) => <li key={c.idx}><span className="font-medium">{c.campo}:</span> Roge «{c.roge}» · archivo «{c.archivo}» (no se toma)</li>)}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};
